export class BarcodeScanner {
  constructor(element) {
    if (!element) {
      return;
    }

    this.element = element;
    this._init();
  }

  _init() {
    console.log('Barcode Scanner');

    this.startTime = 0;
    this.firstDigitEntered = false;
    this.entryType = '';

    this.element.addEventListener('input', (event) => {
      const inputElement = event.target;
      const inputValue = inputElement.value.trim();

      if (inputValue.length === 0) {
        // Reset state if input is empty
        this.startTime = 0;
        this.firstDigitEntered = false;
        return;
      }

      if (!this.firstDigitEntered) {
        // Start the timer when the first digit appears
        this.startTime = performance.now();
      }

      this.firstDigitEntered = true;

      if (event.inputType === 'insertFromPaste') {
        this.entryType = 'Pasted';
        return;
      }

      if (inputValue.length > 1) {
        this.entryType = 'Manual';
        // Measure the elapsed time when additional digits appear
        const elapsedTime = performance.now() - this.startTime;
        const isFast = elapsedTime < 100;
        if (isFast) {
          this.entryType = 'Scanner';
          this._trimInput(this.element, this.entryType);
        }
      }
    });

    this.element.addEventListener('blur', () => {
      if (this.entryType === 'Manual') {
        return;
      }
      this._trimInput(this.element, this.entryType);
    });
  }

  /* eslint-disable-next-line */
  _trimInput(element, entryType) {
    const attr = element.getAttribute('data-validation-digits-only-length');
    if (!attr) {
      return console.error('Missing "data-validation-digits-only-length" attribute');
    }

    const trimCount = parseInt(attr);
    if (isNaN(trimCount)) {
      return console.error(
        'Invalid "data-validation-digits-only-length" value. Should be a valid number',
      );
    }
    const userInput = element.value.trim();
    const trimmedInput = userInput.slice(-trimCount);
    element.value = trimmedInput;
  }
}
